export default "__VITE_ASSET__Bbcwidvt__"